import React from 'react'
import { ROLE_CAPABILITIES } from '../features/masters/roles/utils/roleCapabilities'

/**
 * Universal Role Capability Badge
 * Displays visual archetype pill: Read-Only, View + Approve, or Full/Modify
 *
 * @param {string} capabilityKey - 'VIEW_ONLY' | 'VIEW_APPROVE' | 'FULL_ACCESS' | 'EMPTY'
 * @param {Object} capability - Direct capability object
 * @param {string} className - Additional CSS classes
 * @param {boolean} showIcon - Whether to display leading icon (default true)
 */
export default function RoleCapabilityBadge({
  capabilityKey,
  capability,
  className = '',
  showIcon = true,
}) {
  const cap =
    capability ||
    ROLE_CAPABILITIES[capabilityKey] ||
    ROLE_CAPABILITIES.FULL_ACCESS

  return (
    <span
      title={cap.description}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-bold tracking-tight transition-colors ${cap.badgeClass} ${className}`}
    >
      {showIcon && (
        <span className="material-symbols-outlined text-[13px]">{cap.icon}</span>
      )}
      <span>{cap.label}</span>
    </span>
  )
}
